export const entriesPolyFill: any = (obj: any) =>
  Object.keys(obj).map((key) => [key, obj[key]]);

if (!Object.entries) {
  Object.entries = entriesPolyFill;
}
